import React from 'react';
import './beyond.css';
import ArrowOutwardIcon from '@mui/icons-material/ArrowOutward';
import CameraIcon from '@mui/icons-material/PhotoCameraOutlined';
import HikingIcon from '@mui/icons-material/HikingOutlined';
import MusicIcon from '@mui/icons-material/HeadphonesOutlined';
import TravelIcon from '@mui/icons-material/TravelExploreOutlined';
import Reveal from '../Reveal/Reveal';
import { blog, interests } from '../../data/profile';

const ICONS = {
  hiking: HikingIcon,
  camera: CameraIcon,
  music: MusicIcon,
};

function Beyond() {
  return (
    <section className="section" id="beyond">
      <div className="container">
        <Reveal className="section-head">
          <span className="section-eyebrow">Beyond work</span>
          <h2 className="section-title">Off the clock</h2>
          <p className="section-sub">
            There is a life outside the data platforms — most of it happens on a
            trail somewhere, with a camera and something playing in my ears.
          </p>
        </Reveal>

        <div className="beyond-grid">
          {interests.map(({ name, icon, description }, index) => {
            const Icon = ICONS[icon] || TravelIcon;
            return (
              <Reveal key={name} className="card interest-card" delay={index * 70}>
                <span className="interest-icon" aria-hidden="true">
                  <Icon />
                </span>
                <h3 className="interest-name">{name}</h3>
                <p className="interest-description">{description}</p>
              </Reveal>
            );
          })}
        </div>

        <Reveal className="card blog-callout" delay={120}>
          <div className="blog-callout-copy">
            <span className="blog-callout-eyebrow">Travel blog</span>
            <h3 className="blog-callout-title">{blog.name}</h3>
            <p className="blog-callout-text">{blog.description}</p>
          </div>
          <a
            className="btn btn--primary blog-callout-cta"
            href={blog.url}
            target="_blank"
            rel="noreferrer"
          >
            Read the blog
            <ArrowOutwardIcon fontSize="small" />
          </a>
        </Reveal>
      </div>
    </section>
  );
}

export default Beyond;
